import { render } from "./App.vue?vue&type=template&id=44651afe&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/jgividen/Documents/louder/repos/sync/ptpn-website/wp-content/plugins/bb-custom-module-examples/assets/js/component-lib/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__